import * as React from 'react';

function SvgRepeatOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M22 11.667v.833a4.18 4.18 0 01-4.167 4.167H6m0 0L9 13.5m-3 3.167L9 19.5M17 7.5H6.167A4.18 4.18 0 002 11.667v.833m15-5L14.5 5M17 7.5L14.5 10" })));
}

export default SvgRepeatOutline;
